import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GlobalUtilsService } from 'src/app/global-utils.service';

/**
 * ANTIGO BOTÃO DE ENVIAR...
 */
// @Component({
//   selector: 'app-input-button',
//   template: `
//     <div
//       class="input-button-wrap"
//       [ngClass]="{
//         tablet: globalUtilsService.isTablet(),
//         mobile: globalUtilsService.isMobile(),
//         disabled: disabled
//       }"
//     >
//       <a
//         (mouseover)="test('mouseover')"
//         (mouseout)="test('mouseout')"
//         (click)="!disabled ? trigger.emit() : undefined"
//       >
//         <span class="label">ENVIAR</span>
//         <app-arrow-icon [over]="over && !disabled"></app-arrow-icon>
//       </a>
//     </div>
//   `,
//   styles: [
//     `
//       .input-button-wrap {
//         display: flex;
//         justify-content: flex-end;
//       }

//       a {
//         display: flex;
//         align-items: center;
//         padding: 5px;
//         cursor: pointer;
//         transition: all 500ms cubic-bezier(0.19, 1, 0.22, 1);
//       }

//       a:hover:not(.disabled) {
//         color: #13a538;
//         transition: all 500ms cubic-bezier(0.19, 1, 0.22, 1);
//       }

//       .label {
//         font-size: 0.34rem;
//         font-weight: 800;
//         letter-spacing: 0.04rem;
//         margin-right: 0.2rem;
//       }

//       app-arrow-icon {
//         margin-top: -0.07rem;
//       }

//       .input-button-wrap.tablet .label {
//         font-size: 0.6rem;
//       }

//       .input-button-wrap.mobile .label {
//         font-size: 0.47rem;
//       }
//     `,
//   ],
// })
@Component({
  selector: 'app-input-button',
  template: `
    <div
      class="input-button-wrap"
      [ngClass]="{
        tablet: globalUtilsService.isTablet(),
        mobile: globalUtilsService.isMobile(),
        disabled: disabled
      }"
    >
      <a
        tabindex="0"
        (mouseover)="test('mouseover')"
        (mouseout)="test('mouseout')"
        (click)="!disabled ? trigger.emit() : undefined"
        (keyup.enter)="!disabled ? trigger.emit() : undefined"
      >
        <span class="label">FAZER SIMULAÇÃO</span>

        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11.5 12.121">
          <g transform="translate(0.75 1.061)">
            <line
              x2="10"
              transform="translate(0 5)"
              fill="none"
              stroke="#000"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
            />
            <path
              d="M12,5l5,5-5,5"
              transform="translate(-7 -5)"
              fill="none"
              stroke="#000"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
            />
          </g>
        </svg>
        <!-- <app-arrow-icon [over]="over && !disabled"></app-arrow-icon> -->
      </a>
    </div>
  `,
  styles: [
    `
      .input-button-wrap {
        display: flex;
        justify-content: flex-end;
      }

      .input-button-wrap.disabled a {
        cursor: default;
        opacity: 0.6;
        outline: none;
      }

      .input-button-wrap.disabled a:hover,
      .input-button-wrap.disabled a:focus {
        background-color: #2acc16;
      }

      .input-button-wrap.disabled a:hover span {
        letter-spacing: 0.04rem;
      }

      .input-button-wrap.disabled a:focus span {
        letter-spacing: 0.04rem;
      }

      a {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        background-color: #2acc16;
        transition: background-color 0.2s;
        font-size: 0.36rem;
        letter-spacing: 0.04rem;
        padding: 0.42rem 1rem;
        border-radius: 1rem;
        font-weight: 600;
        overflow: hidden;
        text-decoration: none;
        color: black;
        cursor: pointer;
      }

      a span {
        transition: letter-spacing 0.2s;
      }

      a svg {
        margin-left: 0.3rem;
        width: 0.3rem;
        height: 100%;
      }

      a:hover {
        background-color: #1fe307;
        transition: background-color 0.4s;
      }

      a:hover span {
        transition: letter-spacing 0.4s;
        letter-spacing: 0.06rem;
      }

      a:focus {
        background-color: #1fe307;
        transition: background-color 0.4s;
      }

      a:focus span {
        transition: letter-spacing 0.4s;
        letter-spacing: 0.06rem;
      }

      .input-button-wrap.tablet a {
        font-size: 0.56rem;
        padding: 0.66rem 0;
      }

      .input-button-wrap.mobile a {
        font-size: 0.5rem;
        padding: 0.68rem 0;
        border-radius: 1.5rem;
      }

      /* a {
        display: flex;
        align-items: center;
        padding: 5px;
        cursor: pointer;
        transition: all 500ms cubic-bezier(0.19, 1, 0.22, 1);
      }

      a:hover:not(.disabled) {
        color: #13a538;
        transition: all 500ms cubic-bezier(0.19, 1, 0.22, 1);
      }

      .label {
        font-size: 0.34rem;
        font-weight: 800;
        letter-spacing: 0.04rem;
        margin-right: 0.2rem;
      }

      app-arrow-icon {
        margin-top: -0.07rem;
      }

      .input-button-wrap.tablet .label {
        font-size: 0.6rem;
      }

      .input-button-wrap.mobile .label {
        font-size: 0.47rem;
      } */
    `,
  ],
})
export class InputButtonComponent {
  over: boolean;

  @Input()
  disabled: boolean = false;

  @Output()
  trigger: EventEmitter<any>;

  constructor(public globalUtilsService: GlobalUtilsService) {
    this.over = false;
    this.trigger = new EventEmitter();
  }

  test(e) {
    if (e === 'mouseover') {
      this.over = true;
    } else {
      this.over = false;
    }
  }
}
